import LoadingIcon from '../../../components/Icons/Loading';
import { Autocomplete, TextField, useTheme } from '@mui/material';
import { useState } from 'react';

export interface ItemProps {
  key: string;
  title: string;
}

export interface CustomAutocompleteProps {
  items: ItemProps[];
  textFieldTitle: string;
  activeItem: string;
  isLoading: boolean;
  noPadding?: boolean;
  setItem: (value: ItemProps | null) => void;
}

const CustomAutocomplete: React.FC<CustomAutocompleteProps> = ({ items, activeItem, textFieldTitle, setItem, isLoading, noPadding }) => {
  const [value, setValue] = useState<ItemProps | null | undefined>(items.filter((c) => c.title?.toLowerCase() === activeItem?.toLowerCase())[0]);
  const theme = useTheme();
  const defaultProps = {
    options: items,
    getOptionLabel: (option: ItemProps) => option.title,
  };
  if (isLoading) return <LoadingIcon />;
  return (
    <Autocomplete
      {...defaultProps}
      sx={{ width: '100%', ...(noPadding ? {} : { padding: theme.spacing(1) }) }}
      id="autocomplete-items"
      value={value}
      data-testid="autocomplete"
      onChange={(_event: any, newValue: ItemProps | null) => {
        setValue(newValue);
        setItem(newValue);
      }}
      renderInput={(params) => <TextField {...params} label={textFieldTitle} />}
    />
  );
};

export default CustomAutocomplete;
